import { render, staticRenderFns } from "./ForumThreadPageAsideFixed.vue?vue&type=template&id=3ad7d768&scoped=true"
import script from "./ForumThreadPageAsideFixed.vue?vue&type=script&lang=js"
export * from "./ForumThreadPageAsideFixed.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadPageAsideFixed.vue?vue&type=style&index=0&id=3ad7d768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad7d768",
  null
  
)

export default component.exports